import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService } from 'gw-portals-document-js';

export default class PolicyService {
    static getAccountPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummaries', [], authHeader);
    }

    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetails', [policyNumber], authHeader);
    }

    static removeDocument(publicID, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('removePolicyDocument'), 'removeDocument', [publicID], authHeader);
    }

    static uploadDocument(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadPolicyDocument'), document, documentMetadata, authHeader);
    }

    static getDocumentUploadToken(params, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('generateUploadToken'), 'generateUploadToken', params, additionalHeaders);
    }

    static getOpenPayrollsExt(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('openPayrollExt'), 'getAuditsForCurrentUser_Ext', ['activevoluntary'], authHeader);
    }

    static getAuditsForPolicy_Ext(policyNumber, listType, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('getAuditsForPolicy_Ext'), 'getAuditsForPolicy_Ext', [policyNumber, listType], authHeader);
    }

    // FB 14847
    static getAvailableRIResourcesForCurrentUser_Ext(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('getAvailableRIResourcesForCurrentUser_Ext'), 'getAvailableRIResourcesForCurrentUser_Ext', [], authHeader);
    }

    /**
     * Retrieves billing terms only.
     *
     * @param {Object} authHeader additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} the promise from the backend call
     * @memberof AccountBillingDetailsService
     */
    static getPolicyBillingTermsExt(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('getPolicyBillingTerms_Ext'), 'getPolicyBillingTerms_Ext', [policyNumber], authHeader);
    }
}
